import { Row, Col, Radio } from 'antd'
import useTranslation from '@/hooks/useTranslation'

import InfoCircle from '../../svgs/InfoCircle'

const RadioGroup = ({
  name,
  label,
  value,
  setValue,
  error,
  options,
}) => {
  const { t } = useTranslation()
  return (
    <>
      <label className='flex gap-8' htmlFor={name}>
        {t(label)}{' '}
        <InfoCircle style={!error ? 'opacity-0' : ''} color='#D93F21' />
      </label>
      <div className='bg-white border border-[#DDD] rounded-lg px-20 py-16'>
        <Radio.Group
          className='w-full'
          value={value}
          onChange={(e) => setValue(e.target.value)}
        >
          <Row justify='space-between'>
            {options.map((option, index) => (
              <Col key={index}>
                <Radio value={option.value}>
                  <span className='text-base !text-black font-semibold'>
                    {t(option.label)}
                  </span>
                </Radio>
              </Col>
            ))}
          </Row>
        </Radio.Group>
      </div>
        <p className='text-danger text-xs mt-4'>{error}</p>
    </>
  )
}

export default RadioGroup
